<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.917 6.92508C12.642 5.64175 9.84199 6.05008 7.97533 7.74175V6.75008C7.97533 6.40008 7.74199 6.16675 7.39199 6.16675C7.04199 6.16675 6.80866 6.40008 6.80866 6.75008V9.37508C6.80866 9.72508 7.04199 9.95842 7.39199 9.95842H10.017C10.367 9.95842 10.6003 9.72508 10.6003 9.37508C10.6003 9.02508 10.367 8.79175 10.017 8.79175H8.61699C9.49199 7.85841 10.717 7.33341 12.0003 7.33341C14.567 7.33341 16.667 9.43341 16.667 12.0001C16.667 12.3501 16.9003 12.5834 17.2503 12.5834C17.6003 12.5834 17.8337 12.3501 17.8337 12.0001C17.8337 9.90008 16.7253 7.97508 14.917 6.92508ZM16.6087 14.0417H13.9837C13.6337 14.0417 13.4003 14.2751 13.4003 14.6251C13.4003 14.9751 13.6337 15.2084 13.9837 15.2084H15.3837C14.5087 16.1417 13.2837 16.6667 12.0003 16.6667C9.43366 16.6667 7.33366 14.5667 7.33366 12.0001C7.33366 11.6501 7.10033 11.4167 6.75033 11.4167C6.40033 11.4167 6.16699 11.6501 6.16699 12.0001C6.16699 15.2084 8.79199 17.8334 12.0003 17.8334C13.517 17.8334 14.917 17.2501 16.0253 16.2001V17.2501C16.0253 17.6001 16.2587 17.8334 16.6087 17.8334C16.9587 17.8334 17.192 17.6001 17.192 17.2501V14.6251C17.192 14.2751 16.9003 14.0417 16.6087 14.0417Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
